import { universalRouterProps } from 'core/universalRouter/types';
import { fetchFilterComponents } from 'store/filterComponent/actions';

export default ({ store: { dispatch } }: universalRouterProps, query: { keyword: string }) => {
  return Promise.all([dispatch(fetchFilterComponents(query))]);
};
